<template>
    <div id="showCampaign"><!--Root Element-->
        <BreadCrumb></BreadCrumb>
        <transition name="fade" mode="out-in">
            <div :key="0" id="loaderContainerAcc" v-if="loading">
                <dot-loader class="loader"></dot-loader>
            </div>
            <div :key="1" v-else>
                <div id="headlineContainer">
                    <h2 style="text-transform: uppercase">{{ headline }}</h2>
                </div>
                <div>
                    <div id="headerContainer">
                        <div class="campaignDetails">
                            <InputDetail class="inputMargin width" label="Kunde" :value="customer ? customer : ''"
                                         :disabled=true></InputDetail>
                            <InputDetail class="inputMargin width" label="Kampagne"
                                         :value="campaignName ? campaignName : ''"
                                         :disabled=true></InputDetail>
                            <InputDetail class="inputMargin width" label="AdSpecial" :value="adSpecial ? adSpecial : ''"
                                         :disabled=true></InputDetail>
                            <InputDetail class="inputMargin width" label="Ansprechpartner"
                                         :value="data.contact_person ? data.contact_person : ''"
                                         :disabled=true></InputDetail>
                            <InputDetail class="inputMargin width" label="Abteilung"
                                         :value="data.department  ? data.department : ''" :disabled=true></InputDetail>
                        </div>
                        <Navbox :style="{width: '240px'}">
                            <div v-for="items in navBox" :key="items.text" @click="items.onclick($event, items.params)">
                                {{ items.text }}
                            </div>
                        </Navbox>
                    </div>
                    <div style="margin-top:15px;">
                        <Accordion customStyle="padding-top: 1em;" @accordionAction="addElement"
                                   @copyElement="copyElement"
                                   @deleteElement="deleteElement"
                                   @addElement="addElement" :content="this.accordion" :multiple=true></Accordion>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import InputDetail from "../../../components/inputs/InputDetail";
import Navbox from "../../../components/navBox/Navbox";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import Accordion from "../../../components/accordion/Accordion";

export default {
    name: "ShowCampaign",
    components: {Accordion, BreadCrumb, Navbox, InputDetail},
    data: function () {
        return {
            //data: null,
            transitionName: "fade",
            test: "",
            value: "",
            navBox: [
                //bei ner loop kann man Funktionen nicht so "this.goTo('irgeneinParameter')" übergeben,
                //weil er sonst bereits beim loopen die Funktion aufruft.
                // Deshalb nur den Funktionsnamen übergeben und die Parameter dazu nochmal separat
                {text: "Kampagne bearbeiten", onclick: this.goTo, params: 'editCampaign'},
                {text: "zum Dashboard", onclick: this.goTo, params: 'showDashboard'},
            ],
            loading: true,
            fn: null
        }
    },
    mounted() {
        this.fn = () => {
            this.updateAccordion();
        };
        if (this.$store.state.sites.sites.length === 0) {
            this.$store.dispatch('sites/fetchAllAdServer');
        }
        this.$root.$on('updateMediumDueTrackinglistChange', this.fn);
    },
    beforeDestroy() {
        this.$root.$off('updateMediumDueTrackinglistChange', this.fn);
    },
    created() {
        this.$store.dispatch('campaign/fetch', this.$route.params.id).then(() => {
                this.loading = false;
                this.init();
            }
        );
    },
    computed: {
        customer: function () {
            return this.data ? this.data.customer : ""
        },
        campaignName: function () {
            return this.data ? this.data.name : ""
        },
        adSpecial: function () {
            return this.data ? this.data.ad_special.name : ""
        },
        headline: function () {
            return this.data ? this.customer + " | " + this.campaignName + " | " + this.adSpecial : " "
        },
        vuexState() {
            return this.$store.state.campaign;
        },
        data() {
            return this.vuexState.campaign;
        },
        accordion() {
            let ret = [];
            //if (this.data && this.data.mediums) {
            for (let i = 0; i < this.data.mediums.length; i++) {
                let icon = this.getIcon(this.data.mediums[i].type);
                //this.data.mediums[i].componentType = 'Medium';
                let tmpMedium = JSON.parse(JSON.stringify(this.data.mediums[i]));
                tmpMedium.componentType = 'Medium';
                ret.push(
                    {
                        id: i + 1,
                        active: i === 0,
                        itemComponentName: "MediumContent",
                        itemComponentProps: tmpMedium,
                        componentType: 'Medium',
                        icon: icon,
                        disableActionIcons: true,
                        status: this.data.mediums[i].tracking_list_id ? this.data.mediums[i].tracking_list.status : null,
                        statusVisible: this.data.mediums[i].tracking_list_id !== null
                    }
                );
            }
            //}
            return ret;
        }
    },
    methods: {
        init() {
            this.updateNavBox();
        },
        getIcon(mediumType) {
            switch (mediumType.toLowerCase()) {
                case 'desktop':
                    return 'icon-device-desktop';
                case 'online':
                    return 'icon-device-xdigital';
                case 'mobile':
                    return 'icon-device-mobile';
                case 'tablet':
                    return 'icon-device-tablet';
            }
        },
        capitalize: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        },
        twoDigitize: function (number) {
            return ("0" + number).slice(-2);
        },
        copyElement: function () {
            this.$noty.success("Hello world!");
        },
        deleteElement: function () {
            console.log('deleteElement');
        },
        addElement: function () {
            console.log('addElement');
        },
        /*async fetchCampaign() {
            try {
                const {data} = await CampaignsRepository.getCampaign(this.$route.params.id, true);
                this.data = data;
            } catch (e) {
                this.$noty.error(e.message);
                console.error(e);
            }
        },*/
        updateNavBox: function () {
            let jiraLink = {
                text: "zum Jira-Ticket",
                onclick: this.goTo,
                params: this.data.jira_ticket_url
            };
            this.navBox.unshift(jiraLink);
        },
        updateAccordion: function (accObj) {
            for (let i = 0; i < this.accordion.length; i++) {
                if (this.accordion[i].itemComponentProps.engagement_hash === accObj.engagement_hash) {
                    this.accordion[i].statusVisible = accObj.tracking_list_id !== null;
                    break;
                }
            }
        },
        goTo: function (e, route) {
            if (route.indexOf("http") !== -1) {
                window.open(route, "_blank");
            } else {
                this.$router.push({name: route, params: {id: this.$route.params.id}});
            }
        }
    }
}
</script>

<style scoped>
#showCampaign {
    width: 100%;
}

#headlineContainer {
    display: flex;
    flex-flow: row;
    min-height: 2rem;
}

#headerContainer {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
}

.campaignDetails {
    display: flex;
    flex-flow: wrap;
    width: 1000px;
}

.campaignDetails .inputContainer:nth-last-child(-n+3) {
    margin-bottom: 0;
}

.loaderContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 10em;
}

#loaderContainerAcc {
    displaY: flex;
    justify-content: center;
    align-items: center;
    height: 40vh;
}

.inputMargin {
    margin-bottom: 18px;
    margin-right: 20px;
}

.width {
    width: 270px;
}
</style>